export default "__VITE_ASSET__Cp3Z5VFR__"